import React from "react";
import { createRoot } from "react-dom/client";

import "../less/index.less";
import { AppContainer } from "./AppContainer";

console.log("B2B Portal - start"); //eslint-disable-line

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<AppContainer />);
